/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VariantCategory } from './VariantCategory';
import {
    VariantCategoryFromJSON,
    VariantCategoryFromJSONTyped,
    VariantCategoryToJSON,
} from './VariantCategory';

/**
 * Representation of a Variant Value Category
 * @export
 * @interface VariantValueCategory
 */
export interface VariantValueCategory {
    /**
     * Name of the variant value category
     * @type {string}
     * @memberof VariantValueCategory
     */
    name?: string;
    /**
     * Sequence number of variant value category
     * @type {number}
     * @memberof VariantValueCategory
     */
    sequence?: number;
    /**
     * Parent category of variant value category
     * @type {Array<VariantCategory>}
     * @memberof VariantValueCategory
     */
    superCategories?: Array<VariantCategory>;
}

/**
 * Check if a given object implements the VariantValueCategory interface.
 */
export function instanceOfVariantValueCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VariantValueCategoryFromJSON(json: any): VariantValueCategory {
    return VariantValueCategoryFromJSONTyped(json, false);
}

export function VariantValueCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantValueCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'sequence': !exists(json, 'sequence') ? undefined : json['sequence'],
        'superCategories': !exists(json, 'superCategories') ? undefined : ((json['superCategories'] as Array<any>).map(VariantCategoryFromJSON)),
    };
}

export function VariantValueCategoryToJSON(value?: VariantValueCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'sequence': value.sequence,
        'superCategories': value.superCategories === undefined ? undefined : ((value.superCategories as Array<any>).map(VariantCategoryToJSON)),
    };
}

